import { useEffect } from 'react';
import { Navigate, Routes, Route, useLocation } from 'react-router-dom';
import Marketing from './pages/Marketing';
import { MARKETING_ROUTES } from './marketing/routes';
import { applySeoTagsForPath } from './i18n/seo';
import Beta from './pages/Beta';
import WelcomeBeta from './pages/WelcomeBeta';
import Privacy from './pages/Privacy';
import Onboarding from './pages/Onboarding';
import RadarWorkspacePage from './pages/RadarWorkspace';
import RadarExpoPage, {RadarExpoClaimPage} from './pages/RadarExpo';

function App() {
  const location = useLocation();
  useEffect(() => {
    applySeoTagsForPath(location.pathname);
    const target = location.hash && document.getElementById(location.hash.slice(1));
    if (target) target.scrollIntoView?.();
    else window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);
  return (
    <Routes>
      {MARKETING_ROUTES.map(route => <Route key={route.path} path={route.path} element={<Marketing />} />)}
      <Route path="/beta" element={<Beta />} />
      <Route path="/welcome-beta" element={<WelcomeBeta />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/buyer-radar/app" element={<RadarWorkspacePage />} />
      <Route path="/buyer-radar/expo" element={<RadarExpoPage />} />
      <Route path="/buyer-radar/expo/claim/:sessionId" element={<RadarExpoClaimPage />} />
      <Route path="/buyer-radar/workspaces/:workspaceId" element={<RadarWorkspacePage />} />
      <Route path="/radar" element={<Navigate to="/buyer-radar" replace />} />
      <Route path="*" element={<Marketing />} />
    </Routes>
  );
}

export default App;
